import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  rootContainer: {
    backgroundColor: theme.palette.background.calculator,
    padding: theme.spacing(5),
    backdropFilter: 'blur(80px)',
    width: '565px',
    maxWidth: '100%',
    minHeight: '784px',
    height: 'auto',
    textAlign: 'initial',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  resetCalculation: {
    position: 'absolute',
    zIndex: theme.zIndex.resetButton,
    cursor: 'pointer',
    right: theme.spacing(5),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(1),
    color: theme.palette.text.sliderTrackColor,
    '& svg': {
      fill: theme.palette.text.sliderTrackColor,
      [theme.breakpoints.down('sm')]: {
        width: '20px',
        height: '20px',
      },
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: -theme.spacing(3),
    },
  },
  calculatorTitle: {
    fontSize: '2rem',
    marginBottom: theme.spacing(3),
    textShadow: `2px 2px 0px ${theme.palette.primary.main}`,
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.5rem',
    },
  },

  calculatorSubtitle: {
    fontSize: '1rem',
    marginBottom: theme.spacing(5),
  },

  calculatorImage: {
    '& object': {
      width: '100%',
    },
    '& img': {
      width: '100%',
    },
  },

  calculatorSliderLabel: {
    marginTop: theme.spacing(5),
    fontWeight: 700,
  },
  calculatorSliderTitle: {
    marginBottom: theme.spacing(1),
    fontSize: '1.5rem',
  },
  calculatorSliderContainer: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: -theme.spacing(1),
  },
  calculatorActionIcon: {
    marginTop: -theme.spacing(0.25),
    padding: theme.spacing(1),
    '& svg': {
      fill: theme.palette.text.primary,
    },
  },
  calculateButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    position: 'relative',
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(2.5),
  },
  slider: {},
  calculateButton: {
    backgroundColor: theme.palette.background.black,
    color: theme.palette.text.secondary,
    fontSize: '1rem',
    borderRadius: theme.spacing(0.25),
    padding: theme.spacing(1.5, 3),
  },

  resetCalculationText: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },

  titleResult: {
    '& > p': {
      fontSize: '1.13rem',
      fontWeight: 500,
      [theme.breakpoints.down('sm')]: {
        fontSize: '1rem',
      },
    },
    '& > h4': {
      textShadow: `2px 2px 0px ${theme.palette.primary.main}`,
    },
  },
  subResult: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: theme.spacing(5),
    '& h4': {
      [theme.breakpoints.down('sm')]: {
        fontSize: '1.25rem',
      },
    },
    '& p': {
      fontSize: '1.13rem',
      fontWeight: 500,
      [theme.breakpoints.down('sm')]: {
        fontSize: '1rem',
      },
    },
  },
  generalReport: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(3),
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    '& > div': {
      width: '47%',
      marginBottom: theme.spacing(3),
    },
    '& p': {
      fontSize: '1.13rem',
      fontWeight: 500,
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.8rem',
      },
    },
    '& h5': {
      fontWeight: 500,
      [theme.breakpoints.down('sm')]: {
        fontSize: '1.25rem',
      },
    },
  },
  reportForm: {
    marginTop: theme.spacing(1),
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(3),
    alignItems: 'center',
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(5),
    },
    '& > div': {
      '&:first-child': { width: '100%' },
      width: '47%',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    '& p': {
      fontSize: '1.13rem',
      fontWeight: 500,
    },
    '& input': {
      paddingBottom: theme.spacing(1),
      paddingTop: theme.spacing(1),
    },
    '& select': {
      background: 'transparent',
      fontSize: '1.13rem',
      fontWeight: 500,
      fontFamily: 'inherit',
      width: '100%',
      border: `3px solid ${theme.palette.secondary.main}`,
      color: theme.palette.secondary.main,
      padding: theme.spacing(0.75),
      borderRadius: '25px',
      outline: 'none',
    },
  },
  reportFormInput: {
    '& input[type=number]': {
      '-moz-appearance': 'textfield',
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  radioGroups: {
    display: 'flex',
    textAlign: 'center',
    justifyContent: 'space-between',
    position: 'relative',
    border: '3px solid transparent',
    gap: theme.spacing(2),
    '& p': {
      border: '3px solid transparent',
      borderRadius: '25px',
      width: '110px',
      padding: theme.spacing(0.25),
    },
    '& input[type="radio"]': {
      position: 'absolute',
      width: '100%',
      height: '100%',
      opacity: '0',
      top: '0',
      left: '0',
    },
    '& input[type="radio"]:checked + p': {
      border: `3px solid ${theme.palette.secondary.main}`,
      borderRadius: '25px',
    },
  },
  radioItems: {
    position: 'relative',
  },
  calculatorFooter: {
    display: 'flex',
    marginTop: theme.spacing(4),
    gap: theme.spacing(4),
    fontSize: '1rem',
    alignItems: 'center',
    color: theme.palette.text.lightGrey,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse',
    },
  },
  reportSecondForm: {
    marginTop: theme.spacing(1),
    '& > p': {
      marginBottom: theme.spacing(1),
    },
  },
  submitSuccessContainer: {
    textAlign: 'center',
  },
  submitSuccessIconContainer: {
    marginBottom: theme.spacing(2),
    '& > div': {
      width: '70% !important',
      zIndex: 0,
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(2),
    },
  },
  submitSuccessTitle: {
    textShadow: `2px 2px 0px ${theme.palette.primary.main}`,
    marginBottom: theme.spacing(4),
  },
  submitSuccessDescription: {
    marginBottom: theme.spacing(4),
  },
  informationContainer: {
    display: 'flex',
    gap: theme.spacing(2),
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.grey,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'start',
    },
  },
  informationIconContainer: {
    marginTop: theme.spacing(0.5),
    '& svg': {
      fill: theme.palette.text.primary,
    },
  },
  informationTitle: {
    textAlign: 'left',
  },
  circularProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: '-12px',
    marginLeft: '-12px',
  },
  errorLabel: {
    color: theme.palette.error.main,
  },

  timelineReportContainer: {
    display: 'flex',
  },

  timelineLine: {
    width: '1px',
    borderRight: '2.5px solid #000',
    position: 'relative',
    top: '11px',
    marginRight: theme.spacing(2),
    marginLeft: theme.spacing(1),
  },

  timelineDataContainer: {
    margin: theme.spacing(0, 2),
  },

  timelineDataLabel: {
    position: 'relative',
    fontWeight: 500,
    '&:after': {
      content: '""',
      position: 'absolute',
      border: '1px solid #000',
      width: '10px',
      top: 'calc(50% - 3px)',
      left: '-38px',
    },
  },

  timelineDataValue: {
    textShadow: `2px 2px 0px ${theme.palette.primary.main}`,
    marginBottom: theme.spacing(3),
  },
}))
